<template>
    <div>
        <vSelect :options="infopointOptions" v-model="ipId" :disabled="disabled" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import infopoint from '@/store/displays/infopoint'
import vSelect from 'vue-select'
//import 'vue-select/dist/vue-select.css'

export default {
    name: "InfopointSelect",
    components: {
        vSelect
    },
    props: {
        value: Number,
        disabled: Boolean
    },
    computed: {
        infopointOptions: function() {
            var ret = [];
            ret.push({ code: "", label: "< Not selected >"});
            for( var a of this.$store.state.infopoint.infopointList ) {
                ret.push({ code: a.id , label: a.uniqueId + ' ' + a.name })
            }
            return ret;
        },
        ipId: {
            get: function() { return this.value },
            set: function(newValue) {
                this.$emit('input' , newValue );
            }
        }
    },
    beforeCreate() {
        if( !this.$store.state.infopoint ) {
            this.$store.registerModule("infopoint" , infopoint )
        }
        this.$store.dispatch('infopoint/getInfopointList');
    }
}
</script>

<style lang="scss">
    @import "vue-select/src/scss/vue-select.scss";
</style>